export default {
    conditionImport: 'เงื่อนไขการนำเข้า',
    firstImportCondition: 'สร้างข้อมูลพนักงานก่อนการอัพโหลดรูปภาพใบหน้า',
    secondImportCondition: 'ไฟล์ต้องเป็นประเภท Zip ไฟล์ รูปภาพประเภท .jpg / .png เเละชื่อรูปภาพตั้งจากรหัสพนักงาน เช่น 12345',
    thirdImportCondition: 'กรุณาตรวจสอบข้อมูลใน Zip ไฟล์ ให้ถูกต้องก่อนที่จะอัพโหลด',
    shouldBeZip: 'ไฟล์ต้องเป็น .Zip',
    importResult: 'ผลลัพธ์การนำเข้า'
}
